import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Blog.css";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user?.role === "admin";

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("https://baseapis.akari.sa/api/Blog/GetBlogs");
        setBlogs(response.data);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };

    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this blog?");
    if (!confirmDelete) return;

    try {
      const response = await axios.post(
        `https://baseapis.akari.sa/api/Blog/DeleteBlogById`,
        '', // Empty body
        {
          params: { 
            id: id 
          }
        }
      );

      if (response.data.success) {
        setBlogs(blogs.filter((b) => b.id !== id));
      }
    } catch (err) {
      console.error("Failed to delete blog:", err);
      alert("Failed to delete blog. Please try again.");
    }
  };

  
  const getExcerpt = (html, length = 150) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent?.slice(0, length) + "...";
  };

  return (
    <div className="blog-list">
      <h2 className="blog-heading">أخبار ومقالات العقارات</h2>
      <p className="blog-subheading">ابقى على اطلاع بأحدث أخبارنا ومقالاتنا</p>

      <div className="blog-cards">
        {blogs.map((blog) => (
          <div key={blog.id} className="blog-card">
            <Link to={`/blogdetails/${blog.id}`}>
              {blog.image && (
                <img src={blog.image} alt="Banner" className="blog-image" />
              )}
            </Link>

            <h3>{blog.title}</h3>
            <div className="blog-content">
              {getExcerpt(blog.content)}
            </div>

            {isAdmin && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(blog.id);
                }}
                className="delete-button"
              >
                Delete
              </button>
            )}

            <Link to={`/blogdetails/${blog.id}`} className="read-more">
              اقرأ المزيد
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;


